import React from "react";
import { AppProvider } from "./contexts/AppContext";
import ContactForm from "./components/ContactFrom";
import ContactList from "./components/ContactList";
import TaskForm from "./components/TaskForm";
import TaskList from "./components/TaskList";
import CalendarView from "./components/CalendarView";
import EmailIntegration from "./components/ EmailIntegration";
import Dashboard from "./components/ Dashboard";

const App = () => {
  return (
    <AppProvider>
      <div className="App">
        <h1>Standalone CRM System</h1>
        <ContactForm />
        <ContactList />
        <TaskForm />
        <TaskList />
        <CalendarView />
        <EmailIntegration />
        <Dashboard />
      </div>
    </AppProvider>
  );
};

export default App;
